<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/K1PHPF/tc-custom/9781439155912.jpg?1730490453893" alt="This image is the cover for the book Maggie Bean in Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Maggie Bean in Love
      </h1>
      <p class="bookDescription body article font2">
        <p>At the start of 8th grade, Maggie Bean is really, truly, 100% happy. She's successfully maintained her weight, moved into a beautiful house her family actually owns, and -- best of all -- fallen in love. That's right--love. The real kind, with actual dates, hand holding, laughing and wishing every perfect moment would never end. Maggie wants nothing more than to bask in the joy of having a boyfriend, being a girlfriend and enjoying eighth grade. But eighth grade is serious -- it's one year closer to high school, college and the rest of her life, and Maggie has a lot to do: academic clubs, the swim team, the Patrol This weight-loss club... On top of that, she is striving to the best friend, daughter, and sister she can be (not to mention girlfriend). Balancing everything requires a lot of careful planning and organizing--and, this time, Maggie's Master Mult-Tasker might not be enough. Can she handle the pressure? Can she be everything to everybody--including herself? And will her new relationship survive while she's figuring it all out?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tricia Rayburn
      </h2>
      
      <p class="authorDescription body article"><B>Tricia Rayburn</B> lives on eastern Long island with her fianc&#233; and crazy shih tzu. She tries to eat vegetables instead of candy but, in her weaker moments, loves Reese's Pieces. <I>The Melting of Maggie Bean</I> is her first novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aladdin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b1989824